import { render, staticRenderFns } from "./Invest.vue?vue&type=template&id=9530b1fa&scoped=true&"
import script from "./Invest.vue?vue&type=script&lang=js&"
export * from "./Invest.vue?vue&type=script&lang=js&"
import style0 from "./Invest.vue?vue&type=style&index=0&id=9530b1fa&lang=less&scoped=true&"
import style1 from "./Invest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9530b1fa",
  null
  
)

export default component.exports